import React, { useEffect, useState } from "react";
import ContentBlock from "../Layout/ContentBlock";
import FilterMenu from "../Layout/FilterMenu";
import TableFilterBox from "../common/TableFilterBox";
import ContentValidation from "../common/ContentValidation";
import Pagination from "../Dashboard/items/Pagination";
import {
    ButtonDelete,
    ButtonSmall,
    SelectForm,
} from "../common/Buttons";
import { IconSearch, IconDuplicate } from "../Layout/Icons";
import { useDispatch, useSelector } from "react-redux";
import { autosys_apply_actions } from "../../helpers/GlobalOptions";
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import {
    duplicateAutosys,
    getAutosys,
    getAutosysOptions,
    removeAutosys,
} from "../../redux/Actions/autosys_action ";
import InputSwitchComponent from "../common/InputSwitchComponent";
import SwitchComp from "../common/SwitchComp";
import InputText from "../orders/accepted_orders/InputFilter";
import { handleKeyDown, onChangeUseState } from "../../helpers/FunctionsGlobal";
import AutosysModal from "./AutosysModal";
import TableProductPreview from "../table/TableProductPreview";
import TabUi from "./TabUi";

const { confirm } = Modal;

const filterInitial = {
    rule_title: "",
    auto_type: "",
    sku: "",
    apply_action: "",
    shop_ids: "",
    status: "",
};

export default function AutosysRules({ tabId, setTabId }) {
    const dispatch = useDispatch();
    const { totals, current, loading, data, options } = useSelector(
        (state) => state.custom
    );
    const [page, setPage] = useState(1);
    const [filters, setFilters] = useState(filterInitial);
    const [filterString, setfilterString] = useState("");

    const [modalPreview, setModalPreview] = useState(false);

    useEffect(() => {
        console.log("1 - ");
        dispatch(getAutosysOptions());
    }, []);

    console.log({ options });
    useEffect(() => {
        console.log("2");
        dispatch(getAutosys(page, filterString));
    }, [filterString, page]);

    const onFilter = () => {
        let filterParams = "";

        if (filters.rule_title)
            filterParams += `&q[rule_title_cont_any]=${filters.rule_title}`;

        if (filters.auto_type)
            filterParams += `&q[auto_type_in][]=${filters.auto_type}&q[auto_type_in][]=all`;

        if (filters.sku)
            filterParams += `&q[autosys_products_sku_cont]=${filters.sku}`;

        if (filters.apply_action)
            filterParams += `&q[apply_action_eq]=${filters.apply_action}`;
        if (filters.shop_ids)
            filterParams += `&q[order_shops_id_in]=${filters.shop_ids}`;

        if (filters.status)
            filterParams += `&q[status_present]=${filters.status == "true" ? "1" : "0"
                }`;
        console.log(filterParams);

        setfilterString(filterParams);
        setPage(1);
    };

    const renderCustomButton = () => {
        return (
            <>
                <button
                    type="button"
                    className="btn btn-sm btn-primary ml-3 float-left"
                    onClick={() => setModalPreview(0)}
                >
                    {"Create new"}
                </button>
            </>
        );
    };

    const shops = options?.shops || [];

    return (
        <>
            <ContentBlock>
                <FilterMenu
                    totals={totals}
                    length={data.length}
                    text2="Autosys"
                    countPage={50}
                />
            </ContentBlock>

            <div className="col-12">
                <TabUi tabId={tabId} setTabId={setTabId} />
            </div>

            <ContentBlock containerClass="py-1">
                <TableFilterBox
                    add={false}
                    filter={true}
                    onFilter={() => onFilter()}
                    clearFilter={() => setFilters(filterInitial)}
                    button1={renderCustomButton()}
                >
                    <div className="px-1">
                        <InputText
                            style={{ width: 165, fontSize: "0.75rem" }}
                            name="rule_title"
                            placeholder="Rule title"
                            value={filters.rule_title}
                            onKeyDown={(e) => handleKeyDown(e, onFilter)}
                            onChange={onChangeUseState(setFilters)}
                        />
                    </div>
                    <div className="px-1">
                        <InputText
                            style={{ width: 165, fontSize: "0.75rem" }}
                            placeholder="SKU"
                            name="sku"
                            value={filters.sku}
                            onKeyDown={(e) => handleKeyDown(e, onFilter)}
                            onChange={onChangeUseState(setFilters)}
                        />
                    </div>
                    <div className="px-1">
                        <SelectForm
                            placeholder="Action"
                            style={{ width: 165 }}
                            dropdownMatchSelectWidth={false}
                            options={autosys_apply_actions}
                            onChange={(apply_action) =>
                                setFilters((prev) => ({ ...prev, apply_action }))
                            }
                            value={filters.apply_action || undefined}
                        />
                    </div>
                    <div className="px-1">
                        <SelectForm
                            placeholder="Shop"
                            style={{ width: 165 }}
                            dropdownMatchSelectWidth={false}
                            options={shops}
                            onChange={(shop_ids) =>
                                setFilters((prev) => ({ ...prev, shop_ids }))
                            }
                            value={filters.shop_ids || undefined}
                        />
                    </div>
                    <div style={{ width: "310px" }} className="px-1">
                        <InputSwitchComponent
                            label="When"
                            name="auto_type"
                            options={[
                                {
                                    label: "All",
                                    value: "",
                                },
                                {
                                    label: "Order created",
                                    value: "order_created",
                                },
                                {
                                    label: "Product added",
                                    value: "product_added",
                                },
                            ]}
                            value={filters.auto_type}
                            onChange={onChangeUseState(setFilters)}
                        />
                    </div>
                    <div className="px-1">
                        <InputSwitchComponent
                            label="Status"
                            name="status"
                            options={[
                                {
                                    label: "All",
                                    value: "",
                                },
                                {
                                    label: "Active",
                                    value: "true",
                                },
                                {
                                    label: "Inactive",
                                    value: "false",
                                },
                            ]}
                            value={filters.status}
                            onChange={onChangeUseState(setFilters)}
                        />
                    </div>
                </TableFilterBox>
                <div>
                    <ContentValidation loader={loading} array={data}>
                        <div className="table-responsive" style={{ overflow: "hidden" }}>
                            <table className="table mt-3">
                                <thead>
                                    <tr className="text-muted">
                                        <th className="text-black">#</th>
                                        <th className="text-black">Rule title</th>
                                        <th className="text-black">When</th>
                                        <th className="text-black">User</th>
                                        <th className="text-black">SKU</th>
                                        <th className="text-black">Apply action</th>
                                        <th className="text-black">Shops</th>
                                        <th className="text-black">Period</th>
                                        <th className="text-black">Status</th>
                                        <th className="text-black"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!loading &&
                                        current == "Autosys" &&
                                        data.map((item, idx) => {
                                            return (
                                                <AutosysColumn
                                                    key={item.id}
                                                    idx={idx}
                                                    modalFunc={setModalPreview}
                                                    shops={shops}
                                                    {...item}
                                                />
                                            );
                                        })}
                                </tbody>
                            </table>
                            <Pagination
                                page={1}
                                pageCount={50}
                                totals={totals}
                                setPagination={setPage}
                            />
                        </div>
                    </ContentValidation>
                </div>
            </ContentBlock>

            {typeof modalPreview == "number" && (
                <AutosysModal
                    id={modalPreview}
                    modalFunc={setModalPreview}
                    shops={shops}
                />
            )}
        </>
    );
}

const AutosysColumn = ({
    id,
    modalFunc,
    autosys_products,
    apply_action,
    auto_type,
    rule_title,
    order_shop_id,
    order_shop_ids,
    status,
    shops,
    full_name,
    period,
}) => {
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    return (
        <tr className="align-middle tableColumn">
            <td className="align-middle">#{id}</td>
            <td className="align-middle">{rule_title}</td>
            <td className="align-middle">
                {auto_type.split("_").join(" ").toUpperCase()}
            </td>
            <td className="align-middle">{full_name}</td>
            <td
                className="align-middle"
                style={{
                    width: 300,
                }}
            >
                <TableProductPreview
                    autosys_products={autosys_products}
                    open={open}
                    setOpen={setOpen}
                />
            </td>
            <td className="align-middle">
                {autosys_apply_actions.find((d) => d.value == apply_action)?.label}
            </td>
            <td className="align-middle">
                {order_shop_ids
                    .map((id) => shops.find((d) => d.value === id)?.label)
                    .filter(Boolean)
                    .join(", ")}
            </td>
            <td className="align-middle">{period?.join("-")}</td>
            <td className="align-middle">
                <SwitchComp checked={status} disabled={true} />
            </td>
            <td className="align-middle">
                <div className="d-flex justify-content-end">
                    <ButtonSmall
                        type="outline"
                        onClick={() => {
                            confirm({
                                title: "Are you sure?",
                                icon: <ExclamationCircleOutlined className="text-primary" />,
                                content: "You will not be able to undo this action",
                                onOk() {
                                    dispatch(duplicateAutosys(id));
                                    console.log("OK");
                                },
                                onCancel() {
                                    console.log("Cancel");
                                },
                            });
                        }}
                    >
                        <IconDuplicate color="#03B0F7" />
                    </ButtonSmall>
                    <ButtonSmall
                        className={"mx-2"}
                        onClick={() => {
                            setOpen(false);
                            modalFunc(id);
                        }}
                    >
                        <IconSearch color="#fff" />
                    </ButtonSmall>
                    <ButtonDelete
                        onDelete={() =>
                            confirm({
                                title: "Are you sure?",
                                icon: <ExclamationCircleOutlined className="text-primary" />,
                                content: "You will not be able to undo this action",
                                onOk() {
                                    dispatch(removeAutosys(id));
                                    console.log("OK");
                                },
                                onCancel() {
                                    console.log("Cancel");
                                },
                            })
                        }
                    />
                </div>
            </td>
        </tr>
    );
};
